import axios from 'axios';
import { API_BASE } from './config';

// Single axios instance used by all API modules.
// withCredentials ensures the HttpOnly jwt_token cookie is sent on every request.
const apiClient = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
});

export default apiClient;
